<div class="language-dropdown">
  <ng-container *ifScreenSize="screenType.Desktop">
    <div ngbDropdown #ddLanguage="ngbDropdown">
      <button
        class="language-dropdown-btn rounded bg-language-selector border btn p-0"
        id="languagedropdown"
        attr.aria-label="{{ 'nav.language.screenreader' | translate: { fgbdefault: 'Click for more language menu' } }}"
        ngbDropdownToggle
      >
        <div class="flag-container">
          <img [src]="currentLanguage()?.flag | imgCountryFlag" alt="" />
        </div>
        <span class="text-center">{{ currentLanguage()?.label | translate }}</span>
      </button>
      <div
        ngbDropdownMenu
        (click)="closeDropDown(ddLanguage)"
        aria-labelledby="languagedropdown"
        class="shadow text-center language-dropdown-menu border-0"
      >
        <div class="language-selector-header d-flex align-items-center">
          <span class="language-heading">{{ 'fgbcl.language.selector.title' | translate }}</span>
          <span class="material-icons language-select-close-btn text-info"> close </span>
        </div>
        <ul class="language-list">
          @if (filteredLanguages?.length > 0) {
            @for (language of filteredLanguages; track language.lcid) {
              <a
                class="language-item"
                [class.selected]="currentLanguage()?.lcid === language?.lcid"
                (click)="useLanguage(language)"
              >
                <div class="flag-container">
                  <img [src]="language.flag | imgCountryFlag" alt="" />
                </div>
                <span class="language-code">
                  {{ language.label | translate }}
                </span>
              </a>
            }
          }
        </ul>
      </div>
    </div>
  </ng-container>

  <ng-container *ifScreenSize="screenType.Mobile">
    <button
      class="language-dropdown-btn rounded bg-language-selector border btn p-0"
      id="languagedropdown"
      tabindex="-1"
      attr.aria-label="{{ 'nav.language.screenreader' | translate: { fgbdefault: 'Click for more language menu' } }}"
      (click)="open(content)"
    >
      <div class="flag-container">
        <img [src]="currentLanguage()?.flag | imgCountryFlag" alt="" />
      </div>
      <span class="text-center">{{ currentLanguage()?.label | translate }}</span>
    </button>

    <ng-template #content let-offcanvas>
      <div class="offcanvas-body">
        <div class="language-selector-header">
          <span class="language-heading">{{ 'fgbcl.language.selector.title' | translate }}</span>
          <span class="material-icons language-select-close-btn text-info" (click)="offcanvas.close()"> close </span>
        </div>
        <div class="language-selector-offcanvas-content">
          @if (filteredLanguages?.length > 0) {
            @for (language of filteredLanguages; track language.lcid) {
              <div class="form-check language-item" [class.selected]="language.lcid === selectedLanguage?.lcid">
                <input
                  class="form-check-input"
                  type="radio"
                  [value]="language"
                  name="flexRadioDefault"
                  [(ngModel)]="selectedLanguage"
                  id="language{{ language.lcid }}"
                />
                <label class="form-check-label" for="language{{ language.lcid }}">
                  <div class="flag-container">
                    <img [src]="language.flag | imgCountryFlag" alt="" />
                  </div>
                  <span class="language-code ms-2">
                    {{ language.label | translate }}
                  </span>
                </label>
              </div>
            }
          }
        </div>
        <div class="action-buttons">
          <button class="btn btn-primary bg-language-selector" (click)="useLanguage(selectedLanguage)">
            {{ 'language.selector.offcanvas.select.button' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
